import React from 'react';
import { Button, ButtonModes } from './Button';
import { VideoWithButton } from './VideoWithButton';

const h256 = ['/assets/images/razem-promo-hd.mov', 'video/mp4; codecs=hvc1'];
const webm = ['/assets/images/razem-promo-hd.webm', 'video/webm'];
const mp4 = ['/assets/images/razem-promo-hd.mp4', 'video/mp4'];

const posterMovies = {
  main: ['/assets/images/short_razem_1620.mp4', 'video/mp4; codecs=hvc1'],
  others: [
    ['/assets/images/short_razem_1620.mov', 'video/mp4; codecs=hvc1'],
    ['/assets/images/short_razem_1620.webm', 'video/webm;'],
  ],
};

interface IntroButtons {
  url: string;
  label: string;
}

interface HomePageProps {
  intro: string;
  introButtons: IntroButtons[];
  coverImage?: string;
}

export const HomePageHero: React.FC<HomePageProps> = (props) => (
  <div className="home-hero">
    <h1
      dangerouslySetInnerHTML={
        {
          __html: props.intro,
        }
      }
    />
    <div className="home-hero__actions">
      {props.introButtons.map(({ url, label }, key) => (
        <Button
          mode={key === 0 ? ButtonModes.primary : ButtonModes.secondary}
          url={url}
          newWindow={url.startsWith('https')}
          key={url}
        >
          {label}
        </Button>
      ))}
    </div>

    {props.coverImage && (
      <div className="home-hero__coverImage">
        <img src={props.coverImage} alt="Razem" />
      </div>
    )}

    {!props.coverImage && (
      <div className="home-hero__video">
        <VideoWithButton
          movie={mp4[0]}
          width="100%"
          playsInline
          posterMovies={posterMovies}
        >
          <source
            key={webm[0]}
            src={webm[0]}
            type={webm[1]}
          />
          <source
            key={h256[0]}
            src={h256[0]}
            type={h256[1]}
          />
        </VideoWithButton>
      </div>
    )}

  </div>
);
